var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExActionsPopUp',{attrs:{"value":_vm.show,"headline":"Re-Activate Employee","avatar":_vm.employee,"htmlInfo":_vm.info,"actionLabel":"Re-Activate","data-testid":"reactivate-employee-popup"},on:{"input":function($event){return _vm.$emit('onClose')},"onAction":function($event){return _vm.$emit('onActiveEmployee')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }